import React, { useContext, useEffect, useState } from "react";
import "./PriceCard.scss";
import { formatToPersianAddComma } from "../../../Utils/CommaSeparator";
import { SetDiscountContext } from "../../pages/Pages";

const PriceCard = ({ factorTotal }) => {
	const discountContext = useContext(SetDiscountContext);
	const [isChecked, setIsChecked] = useState(false);
	const Summer = (myArray) => {
		return myArray.reduce((a, b) => Math.floor(+a + +b), 0);
	};

	const checkBoxHandle = () => {
		if (isChecked) {
			setIsChecked(false);
		} else {
			setIsChecked(true);
		}
	};

	function calculateDiscount() {
		let theDiscount = Summer(factorTotal.totalDiscount);

		if (discountContext.type === "percent") {
			if (theDiscount > discountContext.value.maxPrice) {
				theDiscount = discountContext.value.maxPrice;
			} else {
				theDiscount =
					theDiscount +
					(factorTotal.sendPrice * discountContext.value.percent) /
						100;
			}
		} else {
			theDiscount = factorTotal.totalDiscount[0];
		}

		discountContext.setDiscount(theDiscount);

		return theDiscount;
	}

	function calculateTotal() {
		let totalPrice =
			Summer(factorTotal?.total) +
			+factorTotal.sendPrice -
			calculateDiscount();

		if (totalPrice < 0) {
			totalPrice = 0;
		}

		discountContext.setFinalPrice(totalPrice);

		return totalPrice;
	}

	return (
		<>
			<div className="main-price-box">
				<div className="top-box">
					<div className="inline-price">
						<p>جمع مبلـغ کالاها :</p>
						<div className="tmn-price">
							{formatToPersianAddComma(
								Summer(factorTotal.mainPrice)
							)}
							<p>ریال</p>
						</div>
					</div>

					{/* <div className="inline-price">
            <p>تعــداد کـالاهــاا :</p>
            <div className="tmn-price">
              {Summer(factorTotal.sumTe)}
              <p>عدد</p>
            </div>
          </div> */}
					<div className="inline-price">
						<p>مبلغ تخفیف :</p>
						<div className="tmn-price discount-price">
							{formatToPersianAddComma(calculateDiscount())}
							<p>ریال</p>
						</div>
					</div>
					<div className="inline-price">
						<p>سود شما از خرید :</p>
						<div className="tmn-price offer-price">
							{formatToPersianAddComma(
								Summer(factorTotal?.discount)
							)}
							<p>ریال</p>
						</div>
					</div>
				</div>

				<div className="middle-box">
					{
						<div className="inline-price">
							<p>هـزینـه ارســال :</p>
							<div className="tmn-price">
								{formatToPersianAddComma(
									factorTotal?.sendPrice
								)}
								<p>ریال</p>
							</div>
						</div>
					}
				</div>

				<div className="bottom-box">
					<div className="inline-price">
						<p>جمع سبد خرید :</p>
						<div className="tmn-price">
							{formatToPersianAddComma(calculateTotal())}
							<p>ریال</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PriceCard;
